import React, { useEffect, useState } from "react";
import CaSideNav from "../../../../components/AdminComponents/CaSideNav";
import SecondaryNav2 from "../../../../components/AdminComponents/SecondaryNav2";
import {
  CaAdminMenu,
  SecondaryNavCommunications,
} from "../../../../components/AdminComponents/MenuItems";
import { Table, Switch, Pagination, Avatar, Spin } from "antd";
import {
  capitalizeWords,
  remainingViewportHeight,
} from "../../../../components/icons/ApplicationColor";
import { useSelector } from "react-redux";
import { UserOutlined } from "@ant-design/icons";
import Axios from "../../../../api/Axios";
import FilterLogs from "../../../../components/AdminComponents/Modals/FilterLogs";
import CommonTopDetails from "../../../../components/AdminComponents/CommonTopDetails";
const Logs = () => {
  const userInfo = useSelector((state) => state.user);
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const [itemsLength, setItemsLength] = useState();
  const [visible, setVisible] = useState(false);
  const [filterData, setFilterData] = useState({
    pageSize: 15,
    currentPage: 1,
    active: true,
    url: `/maillogslist/${userInfo?.data?.organization?.id}/`,
    search: "",
    filters: "",
    filter_flag: false,
  });
  // eslint-disable-next-line no-unused-vars
  const { pageSize, currentPage, url, search, active, filters, filter_flag } =
    filterData;
  const LoadContacts = async () => {
    let passUrl = url;
    let doNothing = false;
    if (search?.length > 0) {
      if (search.length > 2) {
        passUrl += `?page=${currentPage}&page_size=${pageSize}&search=${search}${filters}`;
      } else {
        doNothing = true;
      }
    } else {
      passUrl += `?page=${currentPage}&page_size=${pageSize}${filters}`;
    }
    if (!doNothing) {
      setLoading(true);
      try {
        const res = await Axios.get(passUrl);
        //console.log(res.data.results);
        setItemsLength(res.data.count);
        setData(res.data.results);
        setLoading(false);

        //console.log(data);
      } catch (err) {
        if (err.response && err.response.status === 404) {
          setLoading(false);
        }
        //console.log(err);
      }
    }
  };
  // const LoadUser = async () => {
  //   try {
  //     const res = await Axios.get("/applicationlist/?status=True");
  //     console.log(res.data);
  //     setApplications(res.data);
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };
  // useEffect(() => {
  //   LoadUser();
  // }, []);
  useEffect(() => {
    LoadContacts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterData]);
  const columns = [
    {
      title: capitalizeWords("SENT BY"),
      dataIndex: "id",
      key: "id",
      width: 200,
      render: (_, record) => (
        <div style={{ display: "flex", alignItems: "center" }}>
          <Avatar
            alt={record?.sent_by?.full_name}
            src={record?.sent_by?.profile_pic || null}
            icon={!record?.sent_by?.profile_pic && <UserOutlined />}
            size="small"
          />
          <span style={{ marginLeft: 8 }}>
            {record?.sent_by?.full_name || "Unknown"}
          </span>
        </div>
      ),
    },
    {
      title: capitalizeWords("RECEIVED BY"),
      dataIndex: "id",
      key: "id",
      width: 200,
      render: (_, record) => (
        <div style={{ display: "flex", alignItems: "center" }}>
          <Avatar
            alt={record?.user?.full_name}
            src={record?.user?.profile_pic || null}
            icon={!record?.user?.profile_pic && <UserOutlined />}
            size="small"
          />
          <span style={{ marginLeft: 8 }}>{record?.user?.full_name}</span>
        </div>
      ),
    },

    {
      title: capitalizeWords("TEMPLATE USED"),
      dataIndex: "templateUsed",
      key: "templateUsed",
      width: 250,
      render: (_, record) => (
        <span style={{ marginLeft: 8 }}>{record?.template?.title}</span>
      ),
    },
    {
      title: capitalizeWords("EMAIL TYPE"),
      dataIndex: "type",
      key: "type",
      width: 150,
    },
    {
      title: capitalizeWords("EMAIL STATUS"),
      dataIndex: "email_status",
      key: "email_status",
      width: 150,
    },
    {
      title: capitalizeWords("SENT TIME"),
      dataIndex: "id",
      key: "id",
      width: 200,
      render: (text, record) => {
        const date = new Date(record?.updated_at);
        const day = date.getDate().toString().padStart(2, "0");
        const month = date.toLocaleString("en-US", { month: "short" });
        const year = date.getFullYear();

        const hours = date.getHours() % 12 || 12;
        const minutes = date.getMinutes().toString().padStart(2, "0");
        const ampm = date.getHours() >= 12 ? "PM" : "AM";

        if (record.updated_at) {
          return `${month}-${day}-${year} ${hours}:${minutes} ${ampm}`;
        } else {
          return "No data recorded";
        }
      },
    },
  ];

  const onShowSizeChange = (current, size) => {
    setFilterData((prevData) => ({
      ...prevData,
      pageSize: size,
    }));
  };

  const onPageChange = (page, pageSize) => {
    setFilterData((prevData) => ({
      ...prevData,
      currentPage: page,
    }));
  };
  const handleSearchChange = (event) => {
    setFilterData((prevData) => ({
      ...prevData,
      search: event.target.value,
      currentPage: 1,
    }));
  };
  const handleCancel = () => {
    setVisible(false);
  };
  const showModal = () => {
    setVisible(true);
  };
  const [applications, setApplications] = useState([]);
  const [selectedApplications, setSelectedApplications] = useState([]);
  const [templates, setTemplates] = useState([]);
  const [selectedTemplates, setSelectedTemplates] = useState([]);
  // const types = ["ENGAGEMENT", "EVENT"];
  // const [selectedTypes, setSelectedTypes] = useState([]);
  const LoadUser = async () => {
    try {
      const res = await Axios.get("/applicationlist/?status=True");
      console.log(res.data);
      setApplications(res.data);
    } catch (err) {
      console.log(err);
    }
  };
  const LoadTemplates = async () => {
    try {
      const res = await Axios.get(
        `/mailtemplatelist/${userInfo?.data?.organization?.id}/`
      );
      console.log(res.data);
      setTemplates(res.data);
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    LoadUser();
    LoadTemplates();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const ResetFields = async () => {
    console.log("reset from modal");

    setSelectedApplications([]);
    setSelectedTemplates([]);
    // setSelectedTypes([]);
    handleCancel();
    setFilterData(() => ({
      pageSize: 15,
      currentPage: 1,
      active: true,
      url: `/maillogslist/${userInfo?.data?.organization?.id}/`,
      search: "",
      filters: "",
      filter_flag: false,
    }));
  };
  const handleApply = async () => {
    console.log(selectedApplications);

    let filter_url = "";
    if (selectedTemplates.length > 0) {
      filter_url += `&template=${selectedTemplates.join(",")}`;
    }
    if (selectedApplications.length > 0) {
      filter_url += `&application=${selectedApplications.join(",")}`;
    }
    // if (selectedTypes.length > 0) {
    //   filter_url += `&type=${selectedTypes.join(",")}`;
    // }
    console.log(filter_url, "filter_url");

    setFilterData((prevData) => ({
      ...prevData,
      filter_flag: true,
      filters: filter_url,
      currentPage: 1,
    }));

    console.log(url);
    setVisible(false);
  };
  return (
    <CaSideNav props={CaAdminMenu}>
      <SecondaryNav2 menuItems={SecondaryNavCommunications} />
      <CommonTopDetails
        title={active ? "Email Logs" : "Failed Logs"}
        titleSuffix={`${itemsLength || 0} Log(s)`}
        searchPlaceholder="Search by..."
        searchAction={handleSearchChange}
        showAddButton={false}
        filterAction={true}
        marginPass="15px"
        filterUrl={filter_flag}
        filterButtonProps={{
          modalType: "PopUP",
          modalProps: showModal,
        }}
        resetButtonProps={{
          modalProps: ResetFields,
        }}
        customContent={
          <Switch
            style={{
              backgroundColor: active ? "#50C878" : "#FF0000",
              minWidth: "90px",
            }}
            checked={active}
            // onChange={handleSwitchChange}
            disabled={loading}
            checkedChildren="DELIVERY"
            unCheckedChildren="BOUNCE"
          />
        }
      />

      <Spin spinning={loading}>
        <Table
          columns={columns}
          dataSource={data}
          size="small"
          rowKey="id"
          bordered
          className="table-container"
          pagination={false}
          style={{ margin: "1rem" }}
          scroll={{
            y: `${remainingViewportHeight(36)}px`,
            x: 1000,
          }}
        />
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            padding: "1rem",
          }}
        >
          <Pagination
            size="small"
            showSizeChanger
            onShowSizeChange={onShowSizeChange}
            onChange={onPageChange}
            pageSizeOptions={["10", "15", "30", "50", "100"]}
            showQuickJumper
            current={currentPage}
            defaultPageSize={pageSize}
            total={itemsLength}
          />
        </div>
      </Spin>
      <FilterLogs
        applications={applications}
        templates={templates}
        // types={types}
        // setSelectedTypes={setSelectedTypes}
        // selectedTypes={selectedTypes}
        setSelectedTemplates={setSelectedTemplates}
        setSelectedApplications={setSelectedApplications}
        selectedApplications={selectedApplications}
        selectedTemplates={selectedTemplates}
        visible={visible}
        ResetFields={ResetFields}
        handleApply={handleApply}
        handleCancel={handleCancel}
      />
    </CaSideNav>
  );
};

export default Logs;
